import { Link } from 'react-router-dom'

const GetStartedCard = ({
    title,
    description,
    btnComponent,
    btnLink,
    btnClass,
    btnText,
    icon,
    flagText = ""
}) => {
    return (
        <div className="get-started__item">
            {flagText && (
                <span className="get-started__flag">
                    {flagText}
                </span>
            )}

            {icon && icon}

            <h2 className="get-started__title">{title}</h2>

            <p className="get-started__description">
                {description}
            </p>

            {btnComponent ? btnComponent : (
                <Link to={btnLink} className={btnClass}>
                    {btnText}
                </Link>
            )}
        </div>
    )
}

export default GetStartedCard